export interface CustomParams {
  [key: string]: string;
}

export interface ViewComponentAppearance {
  background_color: string;
  stroke_color: string;
  shadow_color: string;
  stroke_width: number;
  opacity: number;
  outlined: boolean;
  visible: boolean;
  clickable: boolean;
}

export interface Constraint {
  source_anchor: string;
  target_anchor: string;
  source: string;
  target: string;
  value: number;
  multiplier: number;
}

export interface Layout {
  constraints: Constraint[];
}

export interface ViewComponent {
  name: string;
  type: string;
  source: string;
  placeholder: string;
  layout: Layout;
  appearance: ViewComponentAppearance;
  custom_params?: CustomParams;
}

export interface Method {
  name: string;
}

export interface Task {
  name: string;
  target: string;
  value: string;
}

export interface Event {
  name: string;
  source: string;
  tasks: Task[];
}

export interface Phase {
  sequence: number;
  background_color: string;
  ads: ViewComponent[];
  controls: ViewComponent[];
  methods: Method[];
  events: Event[];
}

export interface AdaptiveRendering {
  orientation: string;
  cache_type: string;
  phases?: Phase[];
  custom_params?: CustomParams;
  sk_ad_network?: any;
}

export const initialAdaptiveRendering: AdaptiveRendering = {
  orientation: "ORIENTATION_SYSTEM",
  cache_type: "CACHE_TYPE_FULL_LOAD",
  phases: [],
};

export const initialViewComponent: ViewComponent = {
  name: "",
  type: "mraid",
  source: "https://...",
  placeholder: "",
  layout: { constraints: [] },
  appearance: {
    background_color: "#000000",
    stroke_color: "#000000",
    shadow_color: "#000000",
    stroke_width: 1.5,
    opacity: 1,
    outlined: true,
    visible: true,
    clickable: true,
  },
};
